import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import SessionConfig from "../../config/session_config"
import { is_empty } from "../../config/validate"
import { Link } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"
import "./materialSupplier.scss"
import DataTable from "react-data-table-component"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Button,
  ButtonGroup,
  Badge,
  CardTitle,
  Label,
  FormGroup,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import showToast from "../../components/Common/viewNotification"
import {
  getMaterialList,
  deleteMaterial,
  cleanMaterial,
} from "../../store/actions"
import MaterialSupplierForm from "./MaterialSupplierForm"
import AsyncSelect from "react-select/async"
import service from "../../api/monitor.service"
import { useTranslation } from "react-i18next"
import MaterialSupplierDelete from "./MaterialSupplierDelete"

const MaterialSupplier = () => {
  const ref = useRef()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  const [toggleSwitch, settoggleSwitch] = useState(false)
  const [modal, setModal] = useState(false)
  const [clearSelectedRows, setclearSelectedRows] = useState(false)
  const [selectRows, setSelectRows] = useState([])
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [data, setData] = useState({
    columns: [],
    selectedRows: [],
    page: 0,
    size: 10,
    enableImport: false,
    fileUpload: null,
  })
  const [supplier, setSupplier] = useState({
    value: 0,
    label: t("monitor:supplierFind"),
  })
  const [currentMaterial, setCurrentMaterial] = useState(null)
  const [isEdit, setIsEdit] = useState(false)

  // header title
    document.title = t("materialSupplier:title") + " | " + t("global:title")
  //#region  store
  const {
    responseDelete,
    loading,
    error,
    loadingSupplier,
    materialList,
    errorResponseList,
  } = useSelector(state => ({
    loading: state.materialSupplier.loading,
    responseDelete: state.materialSupplier.responseDelete,
    materialList: state.materialSupplier.materialList,
    errorResponseList: state.materialSupplier.errorResponseList,
  }))

  useEffect(() => {
    document.title = t("materialSupplier:title") + " | " + t("global:title")
    document.getElementById("body").className = "fondo2"
    initTable()
    loadData()
  }, [data.page, data.size])

  useEffect(() => {
    if (responseDelete !== null) {
      if (responseDelete.length > 0) {
        showToast(
          t("global:msgSuccessDeleteList"),
          "success",
          t("materialSupplier:title")
        )
        dispatch(cleanMaterial())
        loadData()
      }
    }
    if (errorResponseList?.length > 0) {
      errorResponseList?.forEach(element => {
        let showError =
          "Error fila " +
          element.rowNumber +
          " - " +
          element.code +
          " - " +
          element.field
        showToast(showError, "error", t("materialSupplier:error"))
      })
      loadData()
      cleanData()
    } else if (errorResponseList?.length == 0) {
      showToast(
        t("global:msgSuccessSaveList"),
        "success",
        t("materialSupplier:titleViewMaterial")
      )
      cleanData()
      loadData()
    }
  }, [responseDelete, errorResponseList])

  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
    }
  }, [error])
  const toggle = () => {
    setModal(!modal)
  }
  const search = async () => {
    loadData()
  }
  const cleanData = async () => {
    await dispatch(cleanMaterial())
  }
  const loadData = async () => {
    let body = {
      length: data.size,
      page: data.page,
      supplierId: supplier?.id,
    }
    await dispatch(getMaterialList(body))
  }
  const loadSuppliers = filter => {
    if (auth) {
      const json = {
        username: auth?.id?.user?.username,
        length: 30,
        filter,
        societyCode: process.env.REACT_APP_STYLE_TEMPLATE,
      }
      return service.getSupplier(json)
    }
  }

  const loadingOptionSupplier = async (filter, callback) => {
    if (filter.length >= 3) {
      const data = await loadSuppliers(filter)
      const s = data?.data?.map(item => {
        return {
          ...item,
          value: item.code,
          label: item.name + " | " + item.code,
        }
      })
      callback(s)
    }
  }
  const onChangeSupplier = (value, action) => {
    setSupplier(value)
  }

  const handlePageChange = async page => {
    data.page = parseInt(page) - 1
    if (data.page < 0) {
      data.page = 0
    }
    await updateState(data.page, "page")
  }
  const handlePerRowsChange = async (perPage, page) => {
    data.size = perPage
    data.page = parseInt(page) - 1
    if (data.page < 0) {
      data.page = 0
    }
    await updateState(data.size, "size")
    await updateState(data.page, "page")
  }
  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    })
  }
  const initTable = () => {
    data.columns = [
      {
        name: t("materialSupplier:titleCodeSap"),
        sortable: false,
        wrap: true,
        grow: 1,
        cell: row => (
          <div>
            <div className=" text-primary text-uppercase"> {row.codeSap}</div>
          </div>
        ),
      },

      {
        name: t("materialSupplier:titleNameMaterial"),
        sortable: false,
        wrap: true,
        grow: 5,
        cell: row => (
          <div>
            <div className=" "> {row.name}</div>
            <h6 className="text-muted small">{row.description}</h6>
          </div>
        ),
      },

      {
        name: t("materialSupplier:titleSupplier"),
        sortable: false,
        wrap: true,
        grow: 3,
        cell: row => (
          <div>
            <div className=" "> {row.supplier.name}</div>
            <div>
              <Badge color="primary">
                {!isNaN(row.supplier.nit) ? row.supplier.nit : ""}
              </Badge>
            </div>
          </div>
        ),
      },
      {
        name: "Accion",
        cell: row => (
          <div className="d-flex gap-3">
            <Link className="text-success" to="#">
              <i
                className="fa fa-edit font-size-18"
                id="edittooltip"
                onClick={() => editMaterial(row)}
              ></i>
            </Link>
          </div>
        ),
      },
    ]
  }
  const editMaterial = row => {
    setCurrentMaterial(row)
    setIsEdit(true)
    toggle()
  }
  const addFile = () => {
    setCurrentMaterial(null)
    toggle()
  }
  const onClosing = () => {
    setModal(!modal)
    setIsEdit(false)
  }
  const handleRowSelected = React.useCallback(state => {
    setSelectRows(state.selectedRows)
  }, [])
  const changeStatus = async () => {
    setclearSelectedRows(true)
    await dispatch(deleteMaterial(selectRows))
    setclearSelectedRows(false)
    setSelectRows([])
  }

  const handleDelete = () => {
    changeStatus()
    setShowDeleteModal(false)
  }

  const handleClose = () => {
    setShowDeleteModal(false)
  }

  const contextActions = React.useMemo(() => {
    return (
      <React.Fragment>
        <Form>
          <Row>
            <Col>
              <Button
                key="delete"
                color={toggleSwitch ? t("primary") : t("danger")}
                disabled={loading}
                onClick={() => setShowDeleteModal(true)}
              >
                {toggleSwitch ? t("supplier:enabled") : t("supplier:disabled")}
              </Button>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    )
  })
  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={t("global:title")}
            breadcrumbItem={t("materialSupplier:title")}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="h5 mb-4 text-primary">
                    {t("files:filterTitle")}
                  </CardTitle>
                  <Row className="align-items-end mb-4">
                    <Col lg={4} md={6} sm={12}>
                      <FormGroup>
                        <Label className="form-label">
                          {t("filesUpload:lblSupplier")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <div className="d-flex">
                          <div className="flex-grow-1 me-2">
                            <AsyncSelect
                              loadOptions={loadingOptionSupplier}
                              maxMenuHeight={150}
                              cacheOptions
                              classNamePrefix="react-select"
                              isDisabled={loading}
                              placeholder={t("monitor:supplierFind")}
                              name="supplier1"
                              isClearable
                              isLoading={loadingSupplier}
                              onChange={(value, action) =>
                                onChangeSupplier(value, action)
                              }
                            />
                          </div>
                          <Button
                            type="button"
                            color="primary"
                            className="save-user"
                            disabled={loading}
                            onClick={search}
                            style={{ height: "40px" }}
                          >
                            <i className="fas fa-search" />
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col className="d-flex justify-content-end mt-3 mt-lg-0 align-items-end">
                      <ButtonGroup>
                        <Button
                          color="primary"
                          className="font-16"
                          onClick={addFile}
                        >
                          <i className="fas fa-plus-circle me-1" />
                          {t("global:add")}
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>

                  <Row>
                    <DataTable
                      title={
                        <label className="text-primary text-uppercase font-size-16">
                          <i className="fa fa-list font-size-18  me-1 " />
                          {t("materialSupplier:titleViewMaterial")}
                        </label>
                      }
                      data={
                        materialList?.materialSupplierList
                          ? materialList.materialSupplierList
                          : ""
                      }
                      columns={data.columns}
                      fixedHeaderScrollHeight="500px"
                      selectableRows
                      dense
                      onSelectedRowsChange={handleRowSelected}
                      pointerOnHover={true}
                      highlightOnHover
                      pagination
                      paginationServer
                      paginationTotalRows={materialList ? materialList.size : 0}
                      paginationDefaultPage={1}
                      onChangePage={handlePageChange}
                      paginationComponentOptions={{
                        rowsPerPageText: t("tableOptions:rowsPerPageText"),
                        rangeSeparatorText: t(
                          "tableOptions:rangeSeparatorText"
                        ),
                        selectAllRowsItem: true,
                        selectAllRowsItemText: t(
                          "tableOptions:selectAllRowsItemText"
                        ),
                      }}
                      noDataComponent={t("tableOptions:noDataComponent")}
                      progressPending={loading}
                      progressComponent={<LinearIndeterminate />}
                      contextActions={contextActions}
                      persistTableHead
                      onChangeRowsPerPage={handlePerRowsChange}
                      clearSelectedRows={clearSelectedRows}
                      contextMessage={{
                        singular: t("tableOptions:singular"),
                        plural: t("tableOptions:plural"),
                        message: "",
                      }}
                    />
                    <Modal
                      isOpen={modal}
                      toggle={toggle}
                      backdrop={"static"}
                      size="lg"
                    >
                      <ModalHeader
                        toggle={toggle}
                        tag="h4"
                        close={<span></span>}
                      >
                        {t("materialSupplier:titleModal")}
                      </ModalHeader>
                      <ModalBody>
                        <MaterialSupplierForm
                          onClosing={onClosing}
                          onLoad={loadData}
                          currentMaterial={currentMaterial}
                          isEdit={isEdit}
                        />
                      </ModalBody>
                    </Modal>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            isOpen={showDeleteModal}
            toggle={handleDelete}
            backdrop={"static"}
            size="lg"
          >
            <ModalHeader toggle={handleDelete} tag="h4" close={<span></span>}>
              {t("materialSupplier:titledelete")}
            </ModalHeader>
            <ModalBody>
              <MaterialSupplierDelete
                selectRows={selectRows}
                handleDelete={handleDelete}
                handleClose={handleClose}
              />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default MaterialSupplier
